import React from 'react';
import PropTypes from 'prop-types';
import cx from 'clsx';
import { PauseFilled, PlayFilled } from '@nike/nike-design-system-icons';
import styles from './autoplayCarousel.styl';
import { THEMES } from '../../shapes';

export const ProgressPauseButton = React.memo(
  ({
    colorTheme = THEMES.LIGHT,
    isAutoPlaying = false,
    progressCircleRef,
    onPlayPauseClick,
    onFocus,
    translations = {},
  }) => {
    const progressButtonClasses = cx(styles.progressButton, {
      [styles.dark]: colorTheme === THEMES.DARK,
      [styles.paused]: !isAutoPlaying,
    });

    return (
      <button
        className={progressButtonClasses}
        onClick={onPlayPauseClick}
        onFocus={onFocus}
        aria-label={
          isAutoPlaying
            ? translations.autoplayPauseButtonLabel || 'Pause autoplay'
            : translations.autoplayResumeButtonLabel || 'Resume autoplay'
        }
        type="button"
        data-qa="progress-pause-btn"
      >
        <svg
          viewBox="0 0 48 48"
          className={styles.progressTrack}
          aria-hidden="true"
        >
          <circle cx="24" cy="24" r="22"></circle>
        </svg>
        <svg
          viewBox="0 0 48 48"
          ref={progressCircleRef}
          className={styles.progressBar}
          aria-hidden="true"
        >
          <circle cx="24" cy="24" r="22"></circle>
        </svg>
        <span className={styles.playPause} aria-hidden="true">
          {isAutoPlaying ? <PauseFilled /> : <PlayFilled />}
        </span>
      </button>
    );
  },
);

ProgressPauseButton.displayName = 'ProgressPauseButton';

ProgressPauseButton.propTypes = {
  colorTheme: PropTypes.string,
  isAutoPlaying: PropTypes.bool,
  onFocus: PropTypes.func,
  onPlayPauseClick: PropTypes.func,
  progressCircleRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  translations: PropTypes.shape({
    autoplayPauseButtonLabel: PropTypes.string,
    autoplayResumeButtonLabel: PropTypes.string,
  }),
};
